import React from 'react';
import { createContext } from 'react';
import { createContextualCan } from '@casl/react';
import type { AppAbility } from './abilities';

// Create the ability context
export const AbilityContext = createContext<AppAbility>({} as AppAbility);

// Create the Can component for declarative permission checking
export const Can = createContextualCan(AbilityContext.Consumer);

/**
 * Provider component that provides ability context to children
 */
interface AbilityProviderProps {
  ability: AppAbility;
  children: React.ReactNode;
}

export const AbilityProvider: React.FC<AbilityProviderProps> = ({ ability, children }) => {
  return (
    <AbilityContext.Provider value={ability}>
      {children}
    </AbilityContext.Provider>
  );
}; 